import {Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Components/Home/Home';
import Register from './Components/Account/Register';

function App() {
  return (
    <div className="App">
   <Routes>
   <Route exact path="/" element={<Home/>} />
   <Route exact path="/login" element={<Register/>} />
   </Routes>
    </div>
  );
}

export default App;
